import {LogItem} from '@/types'
import {SalesAppointmentStatus, SalesAppointmentType} from '@/types/sales-appointments'

export interface RemovableLogItem extends LogItem {
  isRemovable?: boolean
}

export interface SalesAppointmentLogItem extends RemovableLogItem {
  appointmentId: string
  appointmentType: SalesAppointmentType
  appointmentStatus: SalesAppointmentStatus
  appointmentComment?: string
}

export function mapDataToComments(data: LogItem[] = []): LogItem[] {
  return data.map(item => mapItemToComment(item))
}

export function mapItemToComment(comment: RemovableLogItem): RemovableLogItem {
  return {...comment}
}

export function mapDealerDataToComments(data: LogItem[] = []): LogItem[] {
  return data.map(item => mapDealerItemToComment(item))
}

export function mapDealerItemToComment(comment: any): LogItem {
  return {
    dueDate: undefined,
    text: comment.message,
    timestamp: comment.createdAt,
  }
}
